import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BookOpen, ShoppingCart, User, Menu, X, LogOut, Clock, BookMarked, Phone, FileText, Headphones } from 'lucide-react';
import { ChatWidget } from '../components/student/ChatWidget';
interface StudentLayoutProps {
  children: React.ReactNode;
}
export function StudentLayout({
  children
}: StudentLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const location = useLocation();
  const navigation = [{
    group: 'MY DASHBOARD',
    items: [{
      name: 'My Classes (currently enrolled)',
      href: '/student/my-classes',
      icon: BookMarked
    }, {
      name: 'Available Classes (enroll here)',
      href: '/student/available-classes',
      icon: BookOpen
    }, {
      name: 'Class History',
      href: '/student/class-history',
      icon: Clock
    }, {
      name: 'Manage Profile',
      href: '/student/profile',
      icon: User
    }]
  }, {
    group: 'MY SHOPPING CART',
    items: [{
      name: 'View Cart',
      href: '/student/cart',
      icon: ShoppingCart
    }, {
      name: 'Browse Packages/Classes',
      href: '/student/products',
      icon: BookOpen
    }, {
      name: 'Checkout',
      href: '/student/checkout',
      icon: ShoppingCart
    }, {
      name: 'Order History',
      href: '/student/orders',
      icon: Clock
    }]
  }];
  return <div className="min-h-screen bg-slate-50 flex flex-col" data-id="element-249" data-mp="3jofxxe93s49d">
      {/* Top Bar */}
      <header className="bg-white border-b border-purple-100 h-16 flex items-center justify-between px-4 lg:px-6 sticky top-0 z-30 shadow-sm" data-id="element-250" data-mp="3oly5b07h2bf9">
        <div className="flex items-center gap-4" data-id="element-251" data-mp="1mtt9hdmuqtz9">
          <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="p-2 hover:bg-purple-50 rounded-md lg:hidden" data-id="element-252" data-mp="1mtjhxlm5serg">
            <Menu className="h-6 w-6 text-purple-700" data-id="element-253" data-mp="1gd9uhi7b0oji" />
          </button>
          <h1 className="text-lg font-semibold text-purple-900 hidden sm:block" data-id="element-254" data-mp="1beq7degz56pk">
            Student Portal
          </h1>
        </div>

        <div className="flex items-center gap-4" data-id="element-255" data-mp="17dwgcc88jbsg"></div>
      </header>

      <div className="flex flex-1 relative" data-id="element-256" data-mp="24346xynpob38">
        {/* Sidebar */}
        <aside className={`
            fixed inset-y-0 left-0 z-20 w-64 text-white transform transition-transform duration-200 ease-in-out lg:translate-x-0 lg:static lg:inset-auto
            ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
          `} style={{
        backgroundColor: '#4A2D8F'
      }} data-id="element-257" data-mp="245hzo0ux5b7m">
          <div className="h-full overflow-y-auto flex flex-col" data-id="element-258" data-mp="2mu56oownoanu">
            {/* Logo */}
            <div className="p-4 border-b border-purple-700/50" data-id="element-259" data-mp="2i2wtriw4a75x">
              <div className="flex items-center justify-between mb-2 lg:hidden" data-id="element-260" data-mp="2i1by1py2gi6h">
                <button onClick={() => setIsSidebarOpen(false)} className="p-2 text-purple-300 hover:text-white" data-id="element-261" data-mp="4mdc3jjsn0c4">
                  <X className="h-6 w-6" data-id="element-262" data-mp="dk5sys55yg1m" />
                </button>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/ghnAoYdYcsrnAteaBPC6VB/DSS-logo-notext.png" alt="Desert Sage Seminars" className="w-full max-w-[180px] h-auto" data-id="element-263" data-mp="ikjyo3jaldwh" />
            </div>

            {/* Welcome section */}
            <div className="px-4 py-4 border-b border-purple-700/50" data-id="element-264" data-mp="x8ob4prr4t6t">
              <p className="text-sm font-semibold text-purple-300 uppercase tracking-wider mb-1" data-id="element-265" data-mp="xbk9gf7ihjvs">
                Welcome
              </p>
              <p className="text-white font-bold text-lg" data-id="element-266" data-mp="16axi55nta4fg">Dana Kichen</p>
            </div>

            {/* Nav */}
            <nav className="flex-1 p-4 space-y-6" data-id="element-267" data-mp="1b9qxz4qkm7is">
              {/* MY DASHBOARD group */}
              <div data-id="element-268" data-mp="xkxll4pfl8u2">
                <h3 className="px-2 text-xs font-semibold text-white uppercase tracking-wider mb-2" data-id="element-269" data-mp="xkfh5ksm7ob2">
                  MY DASHBOARD
                </h3>
                <div className="space-y-0.5" data-id="element-270" data-mp="17cl60lnklpm1">
                  {navigation[0].items.map(item => {
                  const isActive = location.pathname === item.href;
                  return <Link key={item.name} to={item.href} className={`
                          group flex items-center px-2 py-2 text-xs font-medium rounded-md transition-colors
                          ${isActive ? 'bg-purple-700 text-white' : 'text-purple-200 hover:bg-purple-700/60 hover:text-white'}
                        `} data-id="element-271" data-mp="emkz6h9ie2gj">
                        <item.icon className={`mr-2.5 h-4 w-4 flex-shrink-0 ${isActive ? 'text-yellow-400' : 'text-purple-400 group-hover:text-yellow-400'}`} data-id="element-272" data-mp="1zz5yxqjp29rp" />
                        {item.name}
                      </Link>;
                })}
                </div>
              </div>

              {/* Instructions button */}
              <div className="px-2" data-id="element-273" data-mp="1tm1oi4071uz4">
                <Link to="/student/instructions" className={`
                    flex items-center justify-center px-3 py-1.5 rounded text-xs font-bold transition-colors
                    ${location.pathname === '/student/instructions' ? 'bg-green-700 text-white' : 'bg-green-500 hover:bg-green-600 text-white'}
                  `} data-id="element-274" data-mp="1xm2emlwnnum0">
                  <FileText className="mr-1.5 h-3.5 w-3.5" data-id="element-275" data-mp="2chicl20cwano" />
                  Instructions
                </Link>
              </div>

              {/* MY SHOPPING CART group */}
              <div data-id="element-276" data-mp="3497o0gb81yi0">
                <h3 className="px-2 text-xs font-semibold text-white uppercase tracking-wider mb-2" data-id="element-277" data-mp="348o44u20h01c">
                  MY SHOPPING CART
                </h3>
                <div className="space-y-0.5" data-id="element-278" data-mp="3ivwnwj9dydox">
                  {navigation[1].items.map(item => {
                  const isActive = location.pathname === item.href;
                  return <Link key={item.name} to={item.href} className={`
                          group flex items-center px-2 py-2 text-xs font-medium rounded-md transition-colors
                          ${isActive ? 'bg-purple-700 text-white' : 'text-purple-200 hover:bg-purple-700/60 hover:text-white'}
                        `} data-id="element-279" data-mp="39v8b1rvqajdm">
                        <item.icon className={`mr-2.5 h-4 w-4 flex-shrink-0 ${isActive ? 'text-yellow-400' : 'text-purple-400 group-hover:text-yellow-400'}`} data-id="element-280" data-mp="2r3nslipb7rdx" />
                        {item.name}
                      </Link>;
                })}
                </div>
              </div>

              {/* Contact Info */}
              <div className="px-2 pt-1" data-id="element-281" data-mp="226x5fswep46a">
                <p className="text-xs font-semibold text-purple-300 uppercase tracking-wider mb-2" data-id="element-282" data-mp="273e25bho8quz">
                  Contact Information
                </p>
                <div className="flex items-start gap-2 text-xs text-purple-200" data-id="element-283" data-mp="2c0xgebedd3mx">
                  <Phone className="h-3.5 w-3.5 mt-0.5 text-purple-400 flex-shrink-0" data-id="element-284" data-mp="2h1l9r3q2lwkb" />
                  <div data-id="element-285" data-mp="1jfnrn7flrt8w">
                    <p className="text-purple-300" data-id="element-286" data-mp="1jc8e491kus9l">For Class Support:</p>
                    <p className="text-white font-medium" data-id="element-287" data-mp="1oe7j1ncytx8n">
                      Call or text: 602-377-6207
                    </p>
                  </div>
                </div>
              </div>

              {/* Listen instead of read */}
              <div className="px-2 pt-4" data-id="element-288" data-mp="1y5226iux0gpv">
                <Link to="/student/dashboard" className="group flex items-start gap-2 px-2 py-2 rounded-md text-purple-200 hover:bg-purple-700/60 hover:text-white transition-colors" data-id="element-289" data-mp="10mscfie5otrl">
                  <Headphones className="h-3.5 w-3.5 mt-0.5 flex-shrink-0 text-purple-400 group-hover:text-yellow-400" data-id="element-290" data-mp="2jvh9k6q0nzk0" />
                  <span className="text-xs leading-snug" data-id="element-291" data-mp="2trklu5el1eko">
                    Prefer to listen instead of read?
                  </span>
                </Link>
              </div>

              {/* Log Off */}
              <div className="px-2 pt-2" data-id="element-292" data-mp="32s0nrafogdnf">
                <button className="flex items-center justify-center gap-2 w-full px-3 py-2 text-sm font-bold rounded-md bg-red-600 text-white hover:bg-red-700 transition-colors" onClick={() => window.location.href = 'https://www.desertsageseminars.com'} data-id="element-293" data-mp="32qxwh1eg096z">
                  <LogOut className="h-4 w-4" data-id="element-294" data-mp="3mfggz5oi6yfc" />
                  Log Off
                </button>
              </div>
            </nav>
          </div>
        </aside>

        {/* Main Content */}
        <main className="flex-1 overflow-y-auto p-4 lg:p-8 w-full" data-id="element-295" data-mp="4x16zxdbfa13">
          <div className="max-w-7xl mx-auto" data-id="element-296" data-mp="4vq2twfyk09g">{children}</div>
        </main>

        {/* Mobile Overlay */}
        {isSidebarOpen && <div className="fixed inset-0 bg-black/50 z-10 lg:hidden" onClick={() => setIsSidebarOpen(false)} data-id="element-297" data-mp="3r5k94fj9joeq" />}
      </div>

      {/* Live chat / help widget (appears on all student pages) */}
      <ChatWidget data-id="element-298" data-mp="3hdef709gawww" />
    </div>;
}